export default "__VITE_ASSET__fb363cdd__"